module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict01-70205662efddb63b80886aebe1d68506.webp";